/**
 * The words a host's Settings screen puts beside a prompter setting, where more
 * than one host says them.
 *
 * Here rather than beside either screen for `script-copy.ts`'s reason: the web
 * and the phone both offer the control (prompter-display tickets 02 and 03), and
 * what the words describe is the setting, not a screen. A phone that reworded
 * them would be a second answer to a question that has one.
 */

/**
 * The Settings row that draws the script mirrored, for a screen read through
 * teleprompter glass, and the line under it: the web's checkbox (prompter-display
 * ticket 02) and the phone's switch (ticket 03).
 *
 * The hint says what the control is for, and then the thing somebody about to
 * film through glass will wonder: whether the take comes out backwards. It does
 * not, on either host: the take is recorded from the camera, and the flip is
 * drawn over the picture.
 */
export const MIRROR_TEXT = "Mirror text";
export const MIRROR_TEXT_HINT =
  "For teleprompter glass. The recording is not mirrored.";

/**
 * The Settings row that sets how far apart the script's lines are drawn: the
 * web's slider (prompter-display ticket 04) and the phone's stepper (ticket 05).
 * Both show the value as {@link lineSpacingValue} says.
 */
export const LINE_SPACING = "Line spacing";

/** A line spacing as both screens show it: `1.0×`, `1.5×`. One decimal always,
 * because it is stored to one and `1×` beside `1.5×` reads as a different kind
 * of number. */
export function lineSpacingValue(spacing: number): string {
  return `${spacing.toFixed(1)}×`;
}
